module.exports = __webpack_public_path__ + "media/svg/turno-tarde-502e1c31.svg";